// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"e79cc4f30d16b395deb7","691":"72c3061ef0b794022fb8"}[chunkId] + ".js";
};